import moment from 'moment'

function format(v, format) {
  if (null === v || undefined === v) {
    return v
  }

  const result = moment(v).format(format)

  if ('Invalid date' === result) {
    return null
  }

  return result
}

export {
  format
}
